import { Component, Input, OnInit } from '@angular/core';
import { ServiceEventDTO } from '../../../api/serviceEvent/serviceEvent';
import { orderBy } from 'src/app/utils/collection-utils';
import { ServiceEventApiService } from 'src/app/api/serviceEvent/serviceEventApiService';

@Component({
    selector: 'asset-service-events',
    templateUrl: './asset-service-events.component.html',
    styleUrls: ['./asset-service-events.component.css'],
    host: {'class': 'service-events'},
    standalone: false
})
export class AssetServiceEventsComponent implements OnInit {
  @Input() assetId: string | undefined = undefined;
  serviceEvents: ServiceEventDTO[] = [];
  loading: boolean = false;

  displayedColumns: string[] = [
    'id',
    'sourceSystemId',
    'sourceSystemName',
    'eventDate',
    'reportUrl',
    'comment',
    'serviceCategory',
    'serviceEngineer',
    'modifiedDate'
  ];

  constructor(private serviceEventApiService: ServiceEventApiService) { }

  ngOnInit(): void {
    if (this.assetId == undefined) {
      console.log("Empty asset, cannot load service events");
      return;
    }

    this.loading = true;
    this.serviceEventApiService.getServiceEventsForAsset(this.assetId)
      .subscribe(x => {
        this.serviceEvents = orderBy(x, y => y.eventDate);;
        this.loading = false;
      });
  }
}
